/*
 * Copyright (c) 2019 brightlamp
 */

import { store } from '@/store'
import { axiosInit } from './axiosSetup';

export default
{
    namespaced: true,
    state:
    {
        totalRecords: 0,
        allResultData: [],
        resultData: '',
        results: [],
        mrnSelections: [],
        testSelections: []
    },
    mutations:
    {
        SET_ALL_RESULT_DATA: (state, payload) =>
        {
            state.allResultData = payload
        },
        SET_TOTAL_RECORDS: (state, payload) =>
        {
            state.totalRecords = payload
        },
        DELETE_RESULT_DATA: (state, payload) =>
        {
            state.allResultData.splice(payload.deleteIndex, 1)
        },
        SET_RESULT_DATA: (state, payload) =>
        {
            state.resultData = payload
        },
        ADD_MRN_SELECTION: (state, payload) =>
        {
            // Toggle selected and not selected
            if (!state.mrnSelections.some(item => item.mrn === payload.mrn))
            {
                state.mrnSelections.push(payload)
            }
            else
            {
                state.testSelections = state.testSelections.filter(item => item.mrn !== payload.mrn);
                state.mrnSelections = state.mrnSelections.filter(item => item.mrn !== payload.mrn)
            }
        },
        ADD_MRN_SELECTION_ONLY: (state, payload) =>
        {
            // Toggle selected and not selected
            if (!state.mrnSelections.some(item => item.mrn === payload.mrn))
            {
                state.mrnSelections.push(payload)
            }
            else
            {
                state.mrnSelections = state.mrnSelections.filter(item => item.mrn !== payload.mrn)
            }
        },
        RESET_MRN_SELECTIONS_FOR_PAGE: (state, payload) =>
        {
            state.testSelections = state.testSelections.filter(item => item.mrn !== payload.mrn);
            state.mrnSelections = state.mrnSelections.filter(item => item.mrn !== payload.mrn)
        },
        RESET_MRN_SELECTIONS: (state) =>
        {
            state.testSelections = [];
            state.mrnSelections = []
        },
        ADD_TEST_SELECTION: (state, payload) =>
        {
            // Toggle selected and not selected
            if (!state.testSelections.some(item => item.eyes[0].id === payload.eyes[0].id))
            {
                state.testSelections.push(payload)
            }
            else
            {
                state.testSelections = state.testSelections.filter(item => item.eyes[0].id !== payload.eyes[0].id)
            }
        }
    },
    actions:
    {
        GET_RESULT_DATA: async (context, payload) =>
        {
            const axios = await axiosInit();
            const response = await axios.get(`/patient-export/${payload.guid}`);
            const resultData = response.data;
            context.commit('SET_RESULT_DATA', resultData)
        },
        GET_ALL_RESULT_DATA: async (context, payload) =>
        {
            const { page, itemsPerPage } = payload.pagination;
            const axios = await axiosInit();
            const response = await axios.get('/patient-export-list/',
            {
                params:
                {
                    page: page,
                    limit: -1 === itemsPerPage ? 2147483647 : itemsPerPage
                }
            });
            context.commit('SET_TOTAL_RECORDS', response.headers['max-count'] * 1);
            const allResultData = response.data;
            for (const resultData of allResultData)
            {
                resultData.createdAt = new Date(resultData.createdAt).toLocaleString();

                if (!('mrn' in resultData))
                {
                    resultData.mrn = 'N/A'
                }

                resultData.eyeLocation = resultData.eyeLocation ? resultData.eyeLocation : 'N/A';

                resultData.visitDate = resultData.visitDate ? new Date(resultData.visitDate).toLocaleString() : 'N/A'
            }
            context.commit('SET_ALL_RESULT_DATA', allResultData)
        },
        DELETE_RESULT_DATA: async (context, payload) =>
        {
            const axios = await axiosInit();
            await axios.delete(`/patient-export/${payload.guid}`);
            context.commit('DELETE_RESULT_DATA', payload)
        },
        EXPORT_RESULT_DATA: async (context, payload) =>
        {
            payload.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const axios = await axiosInit();
            const response = await axios.post('/patient-export', payload,
            {
                params:
                {
                    type: store.getters['auth/CURRENT_USER'].preferences.exportType
                }
            })
        }
    }
}